import {
  AppBar,
  Box,
  Container,
  Drawer,
  Hidden,
  IconButton,
  LinearProgress,
  Toolbar,
  Typography,
  makeStyles,
  Link,
} from '@material-ui/core'
import RouterLink from 'next/link'
import React, { Suspense, useState } from 'react'

import Logo from 'components/Logo'
import Menu from 'components/Menu'
import MenuIcon from '@material-ui/icons/Menu'
import WithRole from './WithRole'
import { UserRoles } from '@dramatikkens-hus-portal/shared'

const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: '#fff',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    overflowX: 'hidden',
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}))

const Layout = ({ children }: Props) => {
  const classes = useStyles()
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            onClick={handleDrawerToggle}
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant="h6">Tildeling</Typography> */}
          <WithRole
            roles={[UserRoles.Admin, UserRoles.Editor, UserRoles.External]}
          >
            <RouterLink href="/" passHref>
              <Link underline="none" color="inherit">
                <Box width="210px">
                  <Logo></Logo>
                </Box>
              </Link>
            </RouterLink>
          </WithRole>
          <WithRole roles={[UserRoles.User]}>
            <RouterLink href="/" passHref>
              <Link underline="none" color="inherit">
                <Box width="210px">
                  <Logo></Logo>
                </Box>
              </Link>
            </RouterLink>
          </WithRole>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer}>
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <Menu />
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            <Menu />
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Suspense fallback={<LinearProgress />}>
          <Container disableGutters maxWidth="lg">
            {children}
          </Container>
        </Suspense>
      </main>
    </div>
  )
}

type Props = {
  children: React.ReactNode
}

export default Layout
